import { createSlice } from '@reduxjs/toolkit';

import { AuthState, FixMe } from '@greenkub-fronts/shared/interface';
import { getRoleFromToken } from '@greenkub-fronts/shared/utils';

import { login } from './useCases/login.use-case';
import { loginWithToken } from './useCases/login-with-token.use-case';
import { loginAsUser } from './useCases/login-as-user.use-case';
import { authCallback } from './useCases/auth-callback.use-case';

export const AUTH_FEATURE_KEY = 'auth';

const authReducerInit = (): AuthState => {
  try {
    const auth = localStorage.getItem('auth') || '';
    const stored = JSON.parse(auth);

    let authCallback;
    let callbackStored;
    try {
      authCallback = localStorage.getItem('auth-callback') || '';
      callbackStored = JSON.parse(authCallback);
    } catch {
      callbackStored = {};
    }

    return {
      isLoggedIn: true,
      loginErrorMsg: '',
      isFetching: false,
      email: stored.email,
      token: stored.token,
      user: stored.user,
      role: getRoleFromToken(),
      isCallback: callbackStored?.token ? true : false,
    };
  } catch {
    return {
      isLoggedIn: false,
      loginErrorMsg: '',
      isFetching: false,
      email: '',
      token: '',
      user: undefined,
      role: 'ANON',
      isCallback: false,
    };
  }
};

export const initialAuthState: AuthState = authReducerInit();

const authSlice = createSlice({
  name: AUTH_FEATURE_KEY,
  initialState: initialAuthState,
  reducers: {
    logout(state) {
      localStorage.removeItem('auth');
      state.isLoggedIn = false;
      state.loginErrorMsg = '';
      state.email = '';
      state.token = '';
      state.user = undefined;
      state.role = 'ANON';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoggedIn = true;
        state.loginErrorMsg = '';
        state.isFetching = false;
        state.email = action.payload.email;
        state.token = action.payload.token;
        state.user = action.payload.profile as FixMe;
        state.role = getRoleFromToken();
      })
      .addCase(login.rejected, (state) => {
        state.isLoggedIn = false;
        state.loginErrorMsg = 'Erreur au cours de la connexion';
        state.isFetching = false;
        state.email = '';
        state.token = '';
        state.user = undefined;
        state.role = 'ANON';
      })
      .addCase(loginWithToken.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(loginWithToken.fulfilled, (state, action) => {
        state.isLoggedIn = true;
        state.loginErrorMsg = '';
        state.isFetching = false;
        state.email = action.payload.email;
        state.token = action.payload.token;
        state.user = action.payload.profile as FixMe;
        state.role = getRoleFromToken();
      })
      .addCase(loginWithToken.rejected, (state) => {
        state.isLoggedIn = false;
        state.loginErrorMsg = 'Erreur au cours de la connexion';
        state.isFetching = false;
        state.email = '';
        state.token = '';
        state.user = undefined;
        state.role = 'ANON';
      })
      .addCase(loginAsUser.fulfilled, (state, action) => {
        state.isLoggedIn = true;
        state.loginErrorMsg = '';
        state.isFetching = false;
        state.email = action.payload.email;
        state.token = action.payload.token;
        state.user = action.payload.profile as FixMe;
        state.role = getRoleFromToken();
        state.isCallback = true;
      })
      .addCase(authCallback.fulfilled, (state, action) => {
        state.isLoggedIn = true;
        state.loginErrorMsg = '';
        state.isFetching = false;
        state.email = action.payload.email;
        state.token = action.payload.token;
        state.user = action.payload.profile;
        state.role = getRoleFromToken();
        state.isCallback = false;
      });
  },
});

export const auth = authSlice.reducer;

export const authActions: FixMe = authSlice.actions;
